var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7763 6.85352H7.70221C7.29852 6.85352 6.98975 7.17064 6.98975 7.58527C6.98975 7.99988 7.29851 8.31702 7.70221 8.31702H15.7763C16.1799 8.31702 16.4887 7.99989 16.4887 7.58527C16.4887 7.17048 16.18 6.85352 15.7763 6.85352Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7763 9.53613H7.70221C7.29852 9.53613 6.98975 9.85326 6.98975 10.2679C6.98975 10.6825 7.29851 10.9996 7.70221 10.9996H15.7763C16.1799 10.9996 16.4887 10.6825 16.4887 10.2679C16.4887 9.85326 16.18 9.53613 15.7763 9.53613V9.53613Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7763 12.2197H7.70221C7.29852 12.2197 6.98975 12.5369 6.98975 12.9515C6.98975 13.3661 7.29851 13.6832 7.70221 13.6832H15.7763C16.1799 13.6832 16.4887 13.3661 16.4887 12.9515C16.4887 12.5369 16.18 12.2197 15.7763 12.2197Z",
    fill: "#8C8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1403 1H10.3382C5.4938 1 1.55176 5.04884 1.55176 10.0244V20.0244C1.55176 20.6099 1.86052 20.8537 2.05053 20.9268C2.1693 20.9757 2.26422 21 2.38299 21C2.78667 21 3.11911 20.6829 3.52281 20.2928C4.04525 19.805 4.85261 19.0489 5.58878 19.0489H13.1404C17.9848 19.0489 21.9269 15.0001 21.9269 10.0245C21.9269 5.04887 17.985 1.00007 13.1404 1.00007L13.1403 1ZM13.1403 17.5854H5.5887C4.54378 17.5854 3.64134 18.244 2.97642 18.8538V10.0245C2.97642 5.85363 6.27729 2.46346 10.3381 2.46346H13.1401C17.201 2.46346 20.5018 5.85372 20.5018 10.0245C20.5018 14.1951 17.2009 17.5855 13.1401 17.5855L13.1403 17.5854Z",
    fill: "#8C8C8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.8b6b98d13025130ef4ea3db78fa29782.svg";
export { ForwardRef as ReactComponent };